import { Component, Inject, OnInit } from '@angular/core';
import { GoogleLoginProvider, SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { DOCUMENT } from '@angular/common';
import { UserApiService } from '../services/user-api.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-signin-component',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent {
  user: SocialUser | undefined;
  alertType: number = 0;
  showMessage = false;
  message = "";
  isErrorPage = false;


  constructor(private userApiService: UserApiService,
    @Inject(DOCUMENT) private document: Document,
    private socialAuthService: SocialAuthService,
    private titleService: Title,
    private route: ActivatedRoute) {
    this.titleService.setTitle("Signin | RankAhead");
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');

    var issue = this.route.snapshot.paramMap.get('issue');

    if (issue == null)
      this.isErrorPage = false;
    else if (issue == "permission-issue")
      this.isErrorPage = true;
    else
      this.isErrorPage = false;
  }

  refreshToken() {
    this.socialAuthService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithGoogle(): void {
    window.location.href = "https://accounts.google.com/o/oauth2/v2/auth?client_id=226015714415-lg7hkqti2helefkhmq68v3a20uhqv7kf.apps.googleusercontent.com&redirect_uri=" + window.location.origin + "/auth/accessToken&response_type=code&scope=https://www.googleapis.com/auth/webmasters.readonly https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email&access_type=offline&include_granted_scopes=true";
  }

  signOut() {
    this.socialAuthService.signOut();
    localStorage.removeItem("access_token");
  }
}
